/**
 * Hybrid LP Header V2 - Interactive gallery.
 * Cloned from xl-landing-header.js (gallery + thumbs + touch swipe).
 * Supports multiple section instances on one page.
 */
(function () {
  'use strict';

  function initSection(section) {
    var track = section.querySelector('[data-hlh2-track]');
    var slides = section.querySelectorAll('[data-hlh2-slide]');
    var thumbs = section.querySelectorAll('[data-hlh2-thumb]');
    var thumbsContainer = section.querySelector('.hlh2__thumbs');
    var prevBtn = section.querySelector('[data-hlh2-prev]');
    var nextBtn = section.querySelector('[data-hlh2-next]');
    var main = section.querySelector('[data-hlh2-main]');
    var total = slides.length;
    var current = 0;

    if (total === 0 || !track) return;

    // Anchor the thumbnail strip at the first thumb on init so the active
    // first slide and its matching thumb are always aligned. Without this,
    // some mobile browsers restore a non-zero scroll position from a
    // previous session.
    if (thumbsContainer) {
      thumbsContainer.scrollLeft = 0;
      thumbsContainer.scrollTop = 0;
    }

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';

      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === current);
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === current);
      });

      var activeThumb = thumbs[current];
      if (activeThumb) {
        activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.getAttribute('data-hlh2-thumb'), 10));
      });
    });

    if (main) {
      var startX = 0;
      main.addEventListener('touchstart', function (e) {
        startX = e.changedTouches[0].screenX;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        var diff = startX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) goTo(current + 1);
          else goTo(current - 1);
        }
      }, { passive: true });
    }
  }

  function initAll() {
    document.querySelectorAll('.hlh2').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when Shopify theme editor adds/reloads the section
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.hlh2');
    if (section) initSection(section);
  });
})();
